/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum TypeEnum {
    P = 'P',
    A = 'A',
}